import { useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { websocketService } from '../../services/websocket';

/**
 * Owner-side global listener: when a camera flags an anomaly (crowd surge,
 * unusual quiet), the device raises it and the hub broadcasts VisionAnomaly.
 * We surface it as a warning toast the moment it fires — the realtime half of
 * the notification the owner also receives in their bell. Mounted once in the
 * owner layout; subscribing to screen groups happens where screens are shown.
 */
export default function VisionAnomalyListener() {
    const { enqueueSnackbar } = useSnackbar();
    useEffect(() => {
        const onAnomaly = (raw: unknown) => {
            const e = raw as { message?: string; ruleId?: string };
            enqueueSnackbar(e?.message ?? `Camera flagged an unusual pattern (${e?.ruleId ?? 'anomaly'}).`, {
                variant: 'warning',
                autoHideDuration: 8000,
            });
        };
        websocketService.on('VisionAnomaly', onAnomaly);
        return () => websocketService.off('VisionAnomaly', onAnomaly);
    }, [enqueueSnackbar]);
    return null;
}
